module.exports = __webpack_public_path__ + "static/kbusiness_1-ccb7f089d54a61d1eab3173b519102e0.mp4";